import React from 'react';
import { View, ViewStyle } from 'react-native';

import { styles } from './styles';

interface ItemDividerProps {
  fullWidth?: boolean;
  style?: ViewStyle;
}

const ItemDivider = ({ fullWidth, style }: ItemDividerProps) => (
  <View style={[styles.container, fullWidth && styles.fullWidth, style]} />
);

export default ItemDivider;
